import React from "react";

function CheckIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      fill="none"
      viewBox="0 0 50 50"
    >
      <path
        fill="#DE2242"
        d="M25 0C11.215 0 0 11.215 0 25s11.215 25 25 25 25-11.215 25-25S38.785 0 25 0zm-4.997 36.032L10.72 26.77l3.53-3.54 5.747 5.738 13.236-13.236 3.535 3.535-16.765 16.765z"
      ></path>
    </svg>
  );
}

export default CheckIcon2;
